function getOverrides(componentName, overrides) {
    const override = overrides && overrides[componentName];
    if (!override) {
        return {};
    }
    return { $style: override.style };
}
export default getOverrides;
